
define('ldsh!modules/editor/templates/section', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-position-box" style="display: none"></div>\n<div class="ed-inner-wrapper js-section-elements"></div>\n';

}
return __p
};});

